import React, { useEffect, useState } from 'react'
import ModalFaculty from './ModalFaculty'
import { APISERVICE } from '../../../services/api.service'
import TablePeriodFaculty from './TablePeriodFaculty'
import Seeker from './Seeker'
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'
import { initialPagination } from 'data/constants'

const currentYear = new Date().getFullYear()

const AdministratorSettings = () => {
    const [faculties, setFaculties] = useState([])
    const [faculty, setFaculty] = useState({})
    const [showModal, setShowModal] = useState(false)
    const [pagination, setPagination] = useState(initialPagination)
    const [facultyNames, setFacultyNames] = useState([])
    const [filters, setFilters] = useState({ periodo: '', nombre: '', gestion: currentYear.toString() })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getFaculties()
        getNamesFaculty()
    }, [])

    const updatePeriodFaculty = async (infoFaculty) => {
        let url = 'periodo/update/?'
        let params = `idPeriod=${infoFaculty.id}`
        const response = await APISERVICE.post(url, params, infoFaculty)
        if (response.success) {
            getFaculties(pagination.currentPage)
            toast.success('Periodo actualizada exitosamente!')
        }
    }

    const getNamesFaculty = async (pageNumber) => {
        let url = 'facultad/?'
        const response = await APISERVICE.get(url)
        setFacultyNames(response.faculties)
    }

    const getFaculties = async (pageNumber = 1, paramsSeeker = filters, pageSize) => {
        try {
            setLoading(true)
            let url = 'facultad/get-faculties-with-periods/?'
            let params = `page=${pageNumber}`
            params = pageSize ? `${params}&pageSize=${pageSize}` : params
            const response = await APISERVICE.post(url, params, paramsSeeker)
            if (response.success === true) {
                setPagination(response.pagination)
                setFaculties(response.faculties)
            } else {
                setFaculties([])
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const createNewManagement = async (periodos = null, gestion = null) => {
        const url = 'facultad/create-faculties'
        let params = periodos ? `periodos=${periodos}` : ''
        params += gestion ? `${params && '&'}gestion=${gestion}` : ''
        const { success, message } = await APISERVICE.get(url, `?${params}`)
        if (success) {
            getFaculties(pagination.currentPage)
            toast.success(message)
        } else {
            toast.error(message)
        }
        return success
    }

    return (
        <div className='contenedor periods'>
            <Seeker
                facultyNames={facultyNames}
                getFacultiesBySeeker={getFaculties}
                setFilters={setFilters}
                createNewManagement={createNewManagement}
            />
            <TablePeriodFaculty
                faculties={faculties}
                setFaculty={setFaculty}
                setShowModal={setShowModal}
                pagination={pagination}
                getFaculties={getFaculties}
                loading={loading}
            />
            <ModalFaculty
                faculty={faculty}
                show={showModal}
                onHide={() => setShowModal(false)}
                setFaculty={setFaculty}
                update={updatePeriodFaculty}
            />
        </div>
    )
}

export default AdministratorSettings
